import { Injectable } from '@angular/core';
import { SessionDetails } from '@libs/shared/interfaces/auth';
import {
  CORE_EVENT_LOGIN,
  CORE_EVENT_LOGOUT,
  CORE_EVENT_SESSION_DETAILS,
  CoreEventLoginData,
  CoreEventLogoutData,
  CoreEvents,
} from '@libs/shared/interfaces/core-events';

import { StorageService } from './storage.service';

const SESSION_DETAILS_KEY = 'details';

@Injectable({ providedIn: 'root' })
export class VaultService {
  constructor(
    private readonly coreEventsLogin: CoreEvents<CoreEventLoginData>,
    private readonly coreEventsLogout: CoreEvents<CoreEventLogoutData>,
    private readonly coreEventsSessionDetails: CoreEvents<SessionDetails | null>,
    private readonly storage: StorageService,
  ) {
    console.debug('[VaultService] constructor');
  }

  public async init(): Promise<void> {
    console.debug('[VaultService] init');

    this.coreEventsLogin.subscribe(CORE_EVENT_LOGIN, (login) => {
      if (!login) {
        return;
      }

      this.setSessionDetails(login.sessionDetails);
    });

    this.coreEventsLogout.subscribe(CORE_EVENT_LOGOUT, (payload) => {
      if (!payload?.logout) {
        return;
      }

      this.removeSessionDetails(payload?.redirect);
    });

    this.coreEventsSessionDetails.publish(CORE_EVENT_SESSION_DETAILS, await this.getSessionDetails());
  }

  private async getSessionDetails(): Promise<SessionDetails | null | undefined> {
    console.debug('[VaultService] getSessionDetails');

    return (await this.storage?.get(SESSION_DETAILS_KEY)) as SessionDetails;
  }

  private async setSessionDetails(sessionDetails: SessionDetails): Promise<void> {
    console.debug('[VaultService] setSessionDetails', sessionDetails);
    this.coreEventsSessionDetails.publish(CORE_EVENT_SESSION_DETAILS, sessionDetails);
    await this.storage?.set(SESSION_DETAILS_KEY, sessionDetails);
  }

  private async removeSessionDetails(redirect?: string): Promise<void> {
    console.debug('[VaultService] removeSessionDetails');

    await this.storage?.remove(SESSION_DETAILS_KEY);

    this.coreEventsSessionDetails.publish(CORE_EVENT_SESSION_DETAILS);

    // Ensure events are processed before redirecting
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    await new Promise((resolve) => setTimeout(resolve, 500));

    window.location.replace(redirect || '/');
  }
}
